import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";
import { useState } from "react";

import { Button } from "@/components/ui/button/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/dropdown-menu";
import { Employee } from "./schema";
import { usePermissionsModal } from "../add-permissions/use-permission-modal";
import { useRemovePermissionModal } from "../remove-permissions/use-permission-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as Employee & {
    permissions: {
      "1": string[];
      "2": string[];
      "3": string[];
    };
  };

  const { onOpenChange, setEmployeeId, setPermissions } = usePermissionsModal();
  const {
    onOpenChange: onRemoveModalChange,
    setEmployeeId: setEmpId,
    setPermissions: setPerms,
  } = useRemovePermissionModal();

  const [open, setOpen] = useState(false);

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
        >
          <DotsHorizontalIcon className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem
          onMouseDown={() => {
            setEmployeeId(originData.id);
            setPermissions(originData?.permissions);
            onOpenChange(true);
            setOpen(false);
          }}
        >
          Add Permissions
        </DropdownMenuItem>

        <DropdownMenuItem
          onMouseDown={() => {
            setEmpId(originData.id);
            setPerms(originData?.permissions);
            onRemoveModalChange(true);
            setOpen(false);
          }}
        >
          Permissions
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
